import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getOrderApprovalNotesFn, loadOrderApprovalNotesParams } from "@tKgpco/Services/OrderApprovalService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<loadOrderApprovalNotesParams, any>;

export const RequestOrderApprovalNotes: HandlerType = async props => {
    const result = await getOrderApprovalNotesFn(props.parameter);

    if (result.length) {
        props.apiResult = result;
        props.parameter?.onSuccess?.(result);
    } else {
        props.parameter?.onError?.("No notes found for this order.");
        return false;
    }
};

export const chain = [RequestOrderApprovalNotes];
const getOrderApprovalNotes = createHandlerChainRunner(chain, "getOrderApprovalNotes");
export default getOrderApprovalNotes;
